import React from 'react'
import config from 'config'
import { get } from 'lodash'
import {
  ResidentialProject,
  RPFiles,
  RPNew,
  RPOverview,
  RPReport
}
from 'containers/pages'
import { Redirect } from 'react-router-dom'

const urlPrefix = `${config.publicPath}/dashboard/awards/:awardId/residential-project(/:rPId)`

export default [
  {
    path: `${urlPrefix}`,
    component: props => (
      <ResidentialProject
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: [
      {
        path: `${urlPrefix}`,
        exact: true,
        component: props => (
          <Redirect to={`${get(props, 'match.params.rPId')}/report`} />
        )
      },
      {
        path: `${urlPrefix}/new`,
        component: props => (
          <RPNew
            params={get(props, 'match.params', {})}
            {...props}
          />
        )
      },
      {
        path: `${urlPrefix}/report`,
        component: props => (
          <RPReport
            params={get(props, 'match.params', {})}
            {...props}
          />
        )
      },
      {
        path: `${urlPrefix}/overview`,
        component: props => (
          <RPOverview
            params={get(props, 'match.params', {})}
            {...props}
          />
        )
      },
      {
        path: `${urlPrefix}/files`,
        component: props => (
          <RPFiles
            params={get(props, 'match.params', {})}
            {...props}
          />
        )
      }
    ]
  }
]
